import { useLocalization } from '@/services/localizationService';

export default function SupportTitle() {
  const { t, data } = useLocalization();
  return (
    <div className="SB30 md:SB42">
      <div>{t(data.support.needHelp)}</div>
      <div className="mt-1">
        {t(data.support.weAreHereForYou, {
          accent: (text) => <span className="text-primary-accent">{text}</span>,
        })}
      </div>
    </div>
  );
}
